export const bookableEventTypeDisplayAmount = (bookableEventType, currency) => {
  if (bookableEventType.amountCents === 0) {
    return "Free"
  }

  if (currency === "USD") {
    return `$${bookableEventType.amountCents / 100}`
  }

  return `${bookableEventType.amountCents / 100} ${currency}`
}

/**
 * Normalize duration unit from API (GraphQL strings, Rails enum integers, or numeric strings).
 * @param {unknown} raw
 * @returns {"minute"|"hour"|"day"}
 */
export const normalizeBookableEventDurationUnit = (raw) => {
  if (raw === "hour" || raw === 1 || raw === "1") return "hour"
  if (raw === "day" || raw === 2 || raw === "2") return "day"
  if (raw === "minute" || raw === 0 || raw === "0") return "minute"
  return "minute"
}

/**
 * Short label for public/website builder cards (e.g. "2 hours", "1 day", "45 min").
 * Accepts camelCase or snake_case keys as returned by builder JSON or GraphQL.
 * @param {{ duration?: number|null, durationUnit?: unknown, duration_unit?: unknown } | null | undefined} item
 * @returns {string}
 */
export const formatBookableEventDurationLabel = (item) => {
  if (item == null || item.duration == null) return ""
  const rawUnit = item.durationUnit ?? item.duration_unit
  const unit = normalizeBookableEventDurationUnit(rawUnit)
  const d = item.duration
  if (unit === "hour") return d === 1 ? "1 hour" : `${d} hours`
  if (unit === "day") return d === 1 ? "1 day" : `${d} days`
  return d === 1 ? "1 min" : `${d} min`
}
